import $ from 'jquery';
import { padNumber } from './utils';

class LivestreamCountdown {
  constructor($element, $countdown, targetTime) {
    this.$element = $element;
    this.targetTime = targetTime;
    this.timer = null;
    this.$countdown = $countdown;
  }

  init() {
    this.tick();
    this.start();
  }

  start() {
    if (this.timer != null) {
      return;
    }

    this.timer = setInterval(this.tick.bind(this), 300);
  }

  stop() {
    if (this.timer == null) {
      return;
    }

    clearInterval(this.timer);
    this.timer = null;
  }

  tick() {
    const seconds = Math.max(Math.floor(this.getRemainingMilliseconds() / 1000), 0);

    if (seconds <= 0) {
      this.stop();
    }

    const d = Math.floor(seconds / 86400);
    const h = Math.floor((seconds - (d * 86400)) / 3600);
    const m = Math.floor((seconds - (d * 86400 + h * 3600)) / 60);
    const s = Math.floor(seconds - (d * 86400 + h * 3600 + m * 60));

    this.updateDisplay(d, h, m, s);
  }

  updateDisplay(days, hours, minutes, seconds) {
    this.$countdown.text(this.generateString(days, hours, minutes, seconds));
  }

  generateString(days, hours, minutes, seconds) {
    return `${padNumber(days)}:${padNumber(hours)}:${padNumber(minutes)}:${padNumber(seconds)}`;
  }

  getRemainingMilliseconds() {
    return this.targetTime.getTime() - Date.now();
  }
}

export { LivestreamCountdown };

export default function initializeLivestreamCountdown() {
  const componentSelector = '.component-livestream-countdown';

  $(componentSelector).each(function initializeCountdownElement() {
    const countdownElement = $(this).find(`${componentSelector}__countdown`).first();

    const countdown = new LivestreamCountdown($(this), countdownElement, new Date($(this).data('target-time')));
    countdown.init();
  });
}
